export default function() {
  return function(type) {
    console.debug(`Dispatcher: ${type}`);
  };
}
